import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import { Nav, Footer } from './components/chrome';
import Home from './pages/Home';
import EquipmentHub from './pages/EquipmentHub';
import EquipmentCategory from './pages/EquipmentCategory';
import ServicesHub from './pages/ServicesHub';
import ServicePage from './pages/ServicePage';
import Government from './pages/Government';
import IndustriesHub from './pages/IndustriesHub';
import IndustryPage from './pages/IndustryPage';
import Manufacturers from './pages/Manufacturers';
import About from './pages/About';
import Contact from './pages/Contact';
import InsightsHub from './pages/InsightsHub';
import ArticlePage from './pages/ArticlePage';
import NotFound from './pages/NotFound';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }
  static getDerivedStateFromError(error) { return { error }; }
  render() {
    if (this.state.error) {
      return (
        <div className="min-h-screen flex items-center justify-center bg-paper p-8">
          <div className="text-center max-w-md">
            <p className="eyebrow text-signal mb-3">Something went wrong</p>
            <h1 className="display text-2xl text-ink mb-4">This section failed to load</h1>
            <button className="btn-primary" onClick={() => window.location.reload()}>Reload the site</button>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}
function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
  return null;
}

function Lenis() {
  useEffect(() => {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    let raf;
    let lenis;
    (async () => {
      const L = (await import('lenis')).default;
      lenis = new L({ lerp: 0.1, smoothWheel: true });
      const loop = (t) => { lenis.raf(t); raf = requestAnimationFrame(loop); };
      raf = requestAnimationFrame(loop);
    })();
    return () => { cancelAnimationFrame(raf); lenis && lenis.destroy(); };
  }, []);
  return null;
}

export default function App() {
  return (
    <ErrorBoundary>
      <HelmetProvider>
        <BrowserRouter>
          <Lenis />
          <ScrollToTop />
          <Nav />
          <main id="main">
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/equipment" element={<EquipmentHub />} />
              <Route path="/equipment/:slug" element={<EquipmentCategory />} />
              <Route path="/services" element={<ServicesHub />} />
              <Route path="/services/:slug" element={<ServicePage />} />
              <Route path="/government" element={<Government />} />
              <Route path="/industries" element={<IndustriesHub />} />
              <Route path="/industries/:slug" element={<IndustryPage />} />
              <Route path="/manufacturers-partners" element={<Manufacturers />} />
              <Route path="/about" element={<About />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/insights" element={<InsightsHub />} />
              <Route path="/insights/:slug" element={<ArticlePage />} />
              <Route path="*" element={<NotFound />} />
            </Routes>
          </main>
          <Footer />
        </BrowserRouter>
      </HelmetProvider>
    </ErrorBoundary>
  );
}